/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginationMetaDto } from './PaginationMetaDto';
import type { PhysicalCountItemDto } from './PhysicalCountItemDto';
export type PhysicalCountItemsListDto = {
    group: PhysicalCountItemsListDto.group;
    data: Array<PhysicalCountItemDto>;
    meta: PaginationMetaDto;
};
export namespace PhysicalCountItemsListDto {
    export enum group {
        SUCCESS = 'success',
        MISSING = 'missing',
        EXCESS = 'excess',
        SCANNED_NOT_AVAILABLE = 'scanned_not_available',
        DUPLICATE = 'duplicate',
    }
}

